import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { DeviceQrResolvePathParameters } from 'api/actions/device-qr-resolve/device-qr-resolve-path-parameters';
import { DeviceQrResolveResponse } from 'api/actions/device-qr-resolve/device-qr-resolve-response';

type DeviceQrResolveQueryParameters = Record<string, any>;

/**
 * The path of the DeviceQrResolve action.
 */
export const deviceQrResolveActionPath = new SweetPath<keyof DeviceQrResolvePathParameters>('/api/device/qr/resolve', {
  path: '{param}',
});

/**
 * Creates a contextualized DeviceQrResolve actions.
 */
export default function createDeviceQrResolveAction(axios: AxiosInstance) {
  return function deviceQrResolveAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: DeviceQrResolveQueryParameters } = {}) {
    const path = deviceQrResolveActionPath.original;

    return axios.request<DeviceQrResolveResponse, DeviceQrResolveResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
